import { MenuResult } from '../../api/Menu/types'

export type MenuState = MenuResult | null

export enum LoadMenuActionTypes {
  LOAD_MENU = 'LOAD_MENU',
  STORE_MENU = 'STORE_MENU',
}
